module.exports = __webpack_public_path__ + "d6eee61d2e20bf97ed0fc5f21a26d93f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/news1.jpg
 ** module id = 514
 ** module chunks = 1
 **/